import { c as _c } from "react/compiler-runtime";
import IconError from '@/components/assets/icon_error.svg';
import { useTranslations } from 'next-intl';
const PremiumPlanUnavailable = () => {
  const $ = _c(5);
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconError className="size-[40px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("premium-plan-unavailable.message");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="mx-auto flex h-full w-full max-w-[517px] flex-col items-center justify-center">{t0}<p className="body1-omni-styles pt-4 text-center whitespace-pre-line text-[var(--color-vive-primary-20)]">{t1}</p></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default PremiumPlanUnavailable;